<template>
  <tbody>
    <tr v-for="(leadAct, idx) in cohort"
        :key="idx"
        @click="navigateToLead(leadAct.agent.key, leadAct.lead.key)"
        class="ut-border-b ut-border-t ut-border-neutral-020 ut-cursor-default ga-event">
      <td :title="leadAct.lead.fullAddress" data-oa-name="full-address" class="ut-py-8 ut-capitalize ut-overflow-hidden ut-whitespace-no-wrap address ga-event" :data-category="gacategory" data-eventlabel="lead" :data-eventvalue="leadAct.lead.key" data-eventvaluetype="lead key">
        {{ leadAct.lead.fullAddress }}
      </td>
      <td class="ut-px-3 ut-whitespace-no-wrap ut-capitalize ga-event" :data-category="gacategory" data-eventlabel="lead" :data-eventvalue="leadAct.lead.key" data-eventvaluetype="lead key">
        {{ leadAct.lead.firstName }}&nbsp;{{ leadAct.lead.lastName }}
      </td>
      <td class="ut-px-3 ga-event" :data-category="gacategory" data-eventlabel="lead" :data-eventvalue="leadAct.lead.key" data-eventvaluetype="lead key">
        <span @click="tryCall(leadAct.lead.phone)" class="ut-cursor-pointer ga-event" :data-category="gacategory" data-eventlabel="phone number" :data-eventvalue="leadAct.lead.key" data-eventvaluetype="lead key">
          {{ tryGetValue(leadAct.lead.phone) }}
        </span>
      </td>
      <td class="ut-px-3 ut-whitespace-no-wrap ga-event" :data-category="gacategory" data-eventlabel="lead" :data-eventvalue="leadAct.lead.key" data-eventvaluetype="lead key">
        {{ tryGetValue(tryGetOtherAgentStats(leadAct.otherAgentStats)) }}
      </td>
      <td class="ut-px-3 ut-whitespace-no-wrap ut-lowercase ga-event" :data-category="gacategory" data-eventlabel="lead" :data-eventvalue="leadAct.lead.key" data-eventvaluetype="lead key">
        {{ getDurationDiffLabel(leadAct.agent.referralDate) }}
      </td>
      <td :title="leadAct.agent.displayName" class="ut-px-3 ga-event" :data-category="gacategory" data-eventlabel="lead" :data-eventvalue="leadAct.lead.key" data-eventvaluetype="lead key">
        <avatar v-if="leadAct.agent.imageUrl" size="sm" :imgSrc="leadAct.agent.imageUrl" />
        <avatar-placeholder v-else class="ut-p-4" />
      </td>
      <td class="ga-event" :data-category="gacategory" data-eventlabel="lead" :data-eventvalue="leadAct.lead.key" data-eventvaluetype="lead key">
        <pill :class="getStageCss(leadAct.agent.leadAgentStageTypeId)" class="ut-px-4 ut-py-2 ut-text-sm ut-border-0 ga-event" :data-category="gacategory" data-eventlabel="lead" :data-eventvalue="leadAct.lead.key" data-eventvaluetype="lead key">
          {{ getStageName(leadAct.agent.leadAgentStageTypeId) }}
        </pill>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { LeadAgentLeadStageTypeId, LeadAgentLeadStageType } from '@/Mapper/LeadAgentLeadStageType';
import Pill from '@/components/Pill.vue';
import Avatar from '@/components/Avatar.vue';
import AvatarPlaceholder from '@/components/AvatarPlaceholder.vue';

export default {
  name: 'LeadCohortsTableBody',
  components: {
    Pill,
    Avatar,
    AvatarPlaceholder,
  },
  props: {
    cohort: { required: true },
    gacategory: { required: false },
  },
  computed: {
    ...mapState({
      user: state => state.userStore.user,
    }),
    ...mapGetters('userStore', [
      'isPrincipal',
      'isManager',
    ]),
  },
  data() {
    return {
      gaEventCall: {
        category: 'Lead Cohorts',
        action: 'Click to call vendor',
        label: `UserKey=${this.$route.params.uk}`,
      },
    };
  },
  methods: {
    getStageName(id) {
      return LeadAgentLeadStageTypeId[id];
    },
    getStageCss(id) {
      const appraisedOrAbove = [
        LeadAgentLeadStageType.Appraised,
        LeadAgentLeadStageType.Appointed,
        LeadAgentLeadStageType.Listed,
      ].includes(id);

      if (appraisedOrAbove) {
        return ['ut-bg-green-040', 'ut-text-green-700'];
      }
      return ['ut-bg-neutral-040', 'ut-text-neutral-900'];
    },
    tryGetValue(value) {
      if (value === undefined || value === null) {
        return '-';
      }
      return value;
    },
    tryCall(phone) {
      const validPhone = phone && phone.trim().length;
      if (validPhone) {
        window.location = `tel: ${phone}`;
      }
    },
    tryGetOtherAgentStats(stats) {
      const appraised = stats.numAppraised;
      const contacted = stats.numContacted;
      const attempted = stats.numAttempted;

      if (appraised) {
        return `${appraised} appraised`;
      }
      if (contacted) {
        return `${contacted} contacted`;
      }
      if (attempted) {
        return `${attempted} attempted`;
      }
      return null;
    },
    getDurationDiffLabel(referralDate) {
      return this.$helpers.getDurationDiffLabel(referralDate, 'days');
    },
    navigateToLead(agentKey, leadKey) {
      if (this.isPrincipal) {
        this.$router.push({
          path: `/${agentKey}/lead/${leadKey}${!!this.user && !!this.user.key ? `/${this.user.key}` : ''}`,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .address {
    text-overflow: ellipsis;
    max-width: 230px;
  }

  tr {
      @apply ut-cursor-pointer;

      &:hover {
            @apply ut-shadow-md;
        }
  }

</style>
